import api from './api';

const save = data => {
  return api.post('/api/ticket/save', data);
};

const uploadAttachments = (files, ticketId, onUploadProgress) => {
  const formData = new FormData();
  formData.append('ticketId', ticketId);

  files.forEach((file, index) => {
    const name =
      file.fileName ||
      file.name ||
      `attachment-${Date.now().toString()}-${index}`;

    formData.append('files', file, name);
  });

  return api.post('/api/ticket/attach', formData, {
    headers: {
      'content-type': 'multipart/form-data',
    },
    onUploadProgress,
  });
};

const getAll = (status, createdById) => {
  return api.get('/api/ticket/get_all', {
    params: {
      status,
      createdById,
    },
  });
};

const getOne = ticketId => {
  return api.get('/api/ticket/get_one', {
    params: {
      ticketId,
    },
  });
};

const update = data => {
  return api.post('/api/ticket/update', data);
};

const TicketService = {
  save,
  uploadAttachments,
  getAll,
  getOne,
  update,
};

export default TicketService;
